import BreadCrumb from "Components/Common/BreadCrumb";
import Loader from "Components/Common/Loader";
import SearchableSelect from "Components/Common/SearchableSelect";
import TableContainer from "Components/Common/TableContainer";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import {
  adminBulkPublishPayslip,
  adminDownloadPayslipPdfById,
  adminGetAllPayslip,
  adminGetComboMember,
} from "helpers/backend_helpers";
import { formatDateTime } from "helpers/globalFunction";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import Flatpickr from "react-flatpickr";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import DownloadPayslipModalExcel from "./DownloadPayslipModalExcel";
import DownloadPayslipModalZip from "./DownloadPayslipModalZip";
import UploadPayslip from "./UploadPayslip";
import DeleteModalPayslip from "./DeletePayslip";

const PayslipList = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [uploadDataModal, setUploadDataModal] = useState<boolean>(false);
  const [downloadModalExcel, setDownloadModalExcel] = useState<boolean>(false);
  const [downloadModalZip, setDownloadModalZip] = useState<boolean>(false);
  const [publishConfirmModal, setPublishConfirmModal] =
    useState<boolean>(false);

  const [selectionMode, setSelectionMode] = useState<boolean>(false);
  const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({});

  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterMember, setFilterMember] = useState<any>(null);
  const [filterStartMonth, setFilterStartMonth] = useState<any>(null);
  const [filterEndMonth, setFilterEndMonth] = useState<any>(null);

  const [flatpickrKey, setFlatpickrKey] = useState(0);

  const getData = () => {
    setLoading(true);
    setRowSelection({});
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (filterMember) {
      query.userId = filterMember.id;
    }

    if (filterStartMonth) {
      query.startPayDate = moment(filterStartMonth)
        .startOf("month")
        .format("YYYY-MM-DD");
    }

    if (filterEndMonth) {
      query.endPayDate = moment(filterEndMonth)
        .endOf("month")
        .format("YYYY-MM-DD");
    }

    adminGetAllPayslip(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            let dibuat = formatDateTime(el.createTime);
            let diperbarui = formatDateTime(el.updateTime);
            let user = el.userDetails.name || "-";
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              dibuat,
              diperbarui,
              user,
            };
          }),
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const toggleSelectionMode = () => {
    setSelectionMode((prev) => !prev);
    setRowSelection({});
  };

  const handleBulkPublish = () => {
    const idPayslip = Object.keys(rowSelection);
    if (idPayslip.length === 0) return;
    setPublishConfirmModal(true);
  };

  const confirmBulkPublish = async () => {
    const idPayslip = Object.keys(rowSelection);
    setPublishConfirmModal(false);

    setLoading(true);
    try {
      await adminBulkPublishPayslip({ idPayslip });
      toast.success("Slip gaji terpilih berhasil diterbitkan.");
      setRowSelection({});
      setSelectionMode(false);
      getData();
    } catch (error) {
      toast.error("Gagal menerbitkan slip gaji.");
    } finally {
      setLoading(false);
    }
  };

  const downloadData = async (data: any) => {
    setLoading(true);
    try {
      const response: any = await adminDownloadPayslipPdfById(data?.id);

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Slip Gaji ${data?.userDetails?.name || ""} - ${moment(data?.payDate).format("MMMM YYYY") || ""}.pdf`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Unduh data berhasil.");
    } catch (error) {
      toast.error("Gagal mengunduh data.");
    } finally {
      setLoading(false);
    }
  };

  const searchMembers = async (name: string) => {
    const query = { name };
    return await adminGetComboMember(query);
  };

  const formatMemberOption = (member: any) => {
    return {
      label: `${member.name} - ${member.noId}`,
      value: member._id,
    };
  };

  const handleResetFilter = () => {
    setFilterMember(null);
    setFilterStartMonth(null);
    setFilterEndMonth(null);
    setFlatpickrKey((prev) => prev + 1);
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Periode",
        accessorKey: "payDate",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => moment(cell.getValue()).format("MMMM YYYY"),
      },
      {
        header: "Nama",
        accessorKey: "user",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Publikasi",
        accessorKey: "isPublish",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <span
            className={`badge bg-${cell.getValue() ? "success" : "danger"}-subtle text-${cell.getValue() ? "success" : "danger"} fs-12`}
          >
            {cell.getValue() ? "YA" : "TIDAK"}
          </span>
        ),
      },
      // {
      //   header: "Nominal Gaji",
      //   accessorKey: "salaryAmount",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: (cell: any) => formatCurrency(cell.getValue()),
      // },
      {
        header: "Dibuat",
        accessorKey: "dibuat",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Diperbarui",
        accessorKey: "diperbarui",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Aksi",
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              <UncontrolledTooltip
                target={`downloadSlip-${cellProps.row.original.id}`}
              >
                Download Slip Gaji
              </UncontrolledTooltip>
              <button
                id={`downloadSlip-${cellProps.row.original.id}`}
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  // setData(cellProps.row.original);
                  downloadData(cellProps.row.original);
                }}
              >
                <i className="ri-download-2-line align-bottom" />
              </button>

              <UncontrolledTooltip target={`edit-${cellProps.row.original.id}`}>
                Edit
              </UncontrolledTooltip>
              <button
                id={`edit-${cellProps.row.original.id}`}
                className="btn btn-sm btn-soft-warning edit-list"
                onClick={() => {
                  navigate(`/slip-gaji/edit/${cellProps.row.original.id}`);
                }}
              >
                <i className="ri-pencil-fill align-bottom" />
              </button>

              <UncontrolledTooltip
                target={`delete-${cellProps.row.original.id}`}
              >
                Hapus
              </UncontrolledTooltip>
              <button
                id={`delete-${cellProps.row.original.id}`}
                className="btn btn-sm btn-soft-danger remove-list"
                onClick={() => {
                  setDeleteModal(true);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-delete-bin-5-fill align-bottom" />
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  useEffect(() => {
    const isPartialRange =
      (filterStartMonth && !filterEndMonth) ||
      (!filterStartMonth && filterEndMonth);

    if (isPartialRange) return;

    getData();
  }, [pagination, sort, dir, filterMember, filterStartMonth, filterEndMonth]);

  const handleAddClick = () => {
    navigate("/slip-gaji/tambah");
  };

  document.title = "Data Slip Gaji";

  return (
    <React.Fragment>
      <div className="page-content">
        <UploadPayslip
          show={uploadDataModal}
          onCloseClick={() => setUploadDataModal(false)}
          getData={getData}
        />

        <DownloadPayslipModalExcel
          show={downloadModalExcel}
          onCloseClick={() => setDownloadModalExcel(!downloadModalExcel)}
        />

        <DownloadPayslipModalZip
          show={downloadModalZip}
          onCloseClick={() => setDownloadModalZip(!downloadModalZip)}
        />

        <Modal
          isOpen={publishConfirmModal}
          toggle={() => setPublishConfirmModal(false)}
          centered
        >
          <ModalBody className="py-3 px-4">
            <div className="text-center">
              <i className="ri-send-plane-line display-5 text-primary" />
              <div className="mt-4">
                <h4>Terbitkan Slip Gaji?</h4>
                <p className="text-muted mx-4 mb-0">
                  Anda akan menerbitkan {Object.keys(rowSelection).length} slip
                  gaji terpilih.
                </p>
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button
                type="button"
                className="btn w-sm btn-light"
                onClick={() => setPublishConfirmModal(false)}
              >
                Batal
              </button>
              <button
                type="button"
                className="btn w-sm btn-primary"
                onClick={confirmBulkPublish}
              >
                Ya, Terbitkan
              </button>
            </div>
          </ModalBody>
        </Modal>

        <DeleteModalPayslip
          show={deleteModal}
          onCloseClick={() => setDeleteModal(false)}
          getData={() => getData()}
          data={data}
          setData={() => setData({})}
        />

        <Container fluid>
          <BreadCrumb title="Data Slip Gaji" pageTitle="Gaji" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">
                      Data Slip Gaji
                    </h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                        {!selectionMode ? (
                          <>
                            <UncontrolledDropdown direction="down">
                              <DropdownToggle
                                className="btn btn-soft-secondary btn-sm"
                                caret
                              >
                                <i className="ri-settings-4-line align-bottom me-1"></i>
                                Unduh / Upload
                              </DropdownToggle>
                              <DropdownMenu end>
                                <DropdownItem
                                  onClick={() => setDownloadModalExcel(true)}
                                >
                                  <i className="ri-file-download-line align-bottom me-1 text-success"></i>
                                  Unduh Data (Excel)
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() => setDownloadModalZip(true)}
                                >
                                  <i className="ri-folder-zip-line align-bottom me-2 text-info"></i>
                                  Unduh Data (ZIP)
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem
                                  onClick={() => setUploadDataModal(true)}
                                >
                                  <i className="ri-file-upload-line align-bottom me-1 text-primary"></i>
                                  Upload Slip Gaji
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>

                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={toggleSelectionMode}
                            >
                              <i className="ri-checkbox-multiple-line align-bottom me-1"></i>
                              Pilih Slip Gaji
                            </button>

                            <button
                              className="btn btn-success btn-sm"
                              onClick={handleAddClick}
                            >
                              <i className="ri-add-line align-bottom me-1"></i>
                              Tambah Slip
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-soft-secondary btn-sm"
                              onClick={toggleSelectionMode}
                            >
                              <i className="ri-close-line align-bottom me-1"></i>
                              Batal
                            </button>

                            <button
                              className="btn btn-primary btn-sm"
                              onClick={handleBulkPublish}
                              disabled={Object.keys(rowSelection).length === 0}
                            >
                              <i className="ri-send-plane-line align-bottom me-1"></i>
                              Terbitkan Slip Terpilih (
                              {Object.keys(rowSelection).length})
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row>
                      <Col lg={4}>
                        <Flatpickr
                          key={`range-${flatpickrKey}`}
                          className="form-control shadow-sm"
                          options={{
                            mode: "range",
                            plugins: [
                              monthSelectPlugin({
                                shorthand: true,
                                dateFormat: "m-Y",
                                altFormat: "F Y",
                              }),
                            ],
                          }}
                          onChange={(selectedDates) => {
                            setFilterStartMonth(selectedDates[0] || null);
                            setFilterEndMonth(selectedDates[1] || null);
                          }}
                          value={[filterStartMonth, filterEndMonth].filter(
                            Boolean,
                          )}
                          placeholder="Pilih rentang bulan"
                        />
                      </Col>
                      <Col lg={3}>
                        <SearchableSelect
                          value={filterMember}
                          onChange={setFilterMember}
                          onSearch={searchMembers}
                          formatOptionLabel={formatMemberOption}
                          placeholder="Cari Karyawan"
                          minSearchLength={2}
                          itemsPerPage={5}
                          isClearable
                        />
                      </Col>
                    </Row>
                  </Collapse>
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                        enableRowSelection={
                          selectionMode
                            ? (row: any) => !row.original.isPublish
                            : false
                        }
                        rowSelection={rowSelection}
                        onRowSelectionChange={setRowSelection}
                        getRowId={(row: any) => row.id}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default PayslipList;
